import { cardDimensions, cardDimensionsMedia, cardDimensionsMediaLegacy } from '../assets/styles/themes/tokens';
import { useNewNavigation } from './useNewNavigation';

const useCardDimensions = () => {
  const showNewNavigation = useNewNavigation();

  return {
    ...(showNewNavigation ? cardDimensionsMedia : cardDimensionsMediaLegacy),
    ...cardDimensions,
  };
};

export default useCardDimensions;
